import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE } from "../config/api";
import ProductCard from "../components/ProductCard/ProductCard";
import "../pages/ProductGrid.css";
import { useLocation, useNavigate } from "react-router-dom";
import { FaFilter, FaTimes } from "react-icons/fa";

/* const LEGACY_PRICE_RANGES = [
  { label: "All Prices", value: "" },
  { label: "Under ₹500", value: "0-500" },
  { label: "₹500 - ₹1000", value: "500-1000" },
  { label: "₹1000 - ₹2000", value: "1000-2000" },
  { label: "₹2000 - ₹5000", value: "2000-5000" },
  { label: "₹5000 - ₹10000", value: "5000-10000" },
  { label: "₹10000 and above", value: "10000+" },
]; */

const MATERIALS = [
  "BRASS-CZ-COLOR STONE",
  "SILVER-PLAIN",
  "SILVER- CZ-COLOR STONE",
  "SILVER-CVD (LGD)",
  "SILVER-NATURAL DIAMOND",
  "GOLD-PLAIN",
  "GOLD-CZ-COLOR STONE",
  "GOLD- CVD (LGD)",
  "GOLD-NATURAL DIAMOND",
  "PLATINUM-PLAIN",
  "PLATINUM-CVD (LGD)",
  "PLATINUM-NATURAL DIAMOND",
  "PLATINUM-GOLD-PLAIN",
  "PLATINUM-GOLD-STUDDED (LGD/NATURAL)",
];

const PRICE_RANGES = [
  { label: "All Prices", value: "" },
  { label: "Up to 499", value: "0-499" },
  { label: "500-999", value: "500-999" },
  { label: "1000-2999", value: "1000-2999" },
  { label: "3000-4999", value: "3000-4999" },
  { label: "5000-9999", value: "5000-9999" },
  { label: "10000-14999", value: "10000-14999" },
  { label: "15000-19999", value: "15000-19999" },
  { label: "20000-24999", value: "20000-24999" },
  { label: "25000 and above", value: "25000+" },
];

const GEMSTONE_TYPES = ["PRECIOUS", "SEMI-PRECIOUS", "LAB GROWN (LGD)"];

const GEMSTONE_SHAPES = [
  "Rounds",
  "Emerald cut",
  "Princess cut", 
  "Cushion cut",
  "Heart shape",
  "Marquise",
  "Pear",
  "Trillion",
  "Oval"
];
const GEMSTONE_OPTIONS = {
  "PRECIOUS": [
    "Natural Diamonds",
    "Ruby",
    "Emerald",
    "Coral",
    "Yellow Sapphire",
    "Blue Sapphire",
    "Pearls",
    "Hessonite (Gomed)",
    "Catseye"
  ],
  "SEMI-PRECIOUS": [
    "Amethyst",
    "Peridot",
    "Topaz",
    "Turquoise/Firoza",
    "Malachite",
    "Lapis lazuli",
    "Crystal/Sphatik",
    "Opal",
    "Citrine/Sunela",
    "Pink Tourmaline",
    "Golden pyrite",
    "Rose Quartz",
    "Tiger Eye",
    "Yellow Amber"
  ],
  "LAB GROWN (LGD)": [
    "Diamonds",
    "Ruby",
    "Emerald",
    "Yellow Sapphire",
    "Blue Sapphire"
  ]
};

const SPIRITUAL_ITEMS = [
  "RUDRAKSH",
  "BLOWING COANCH (SHANKH)",
  "RIGHT HAND COANCH (DAKSHINAVARTI)",
  "ONE EYE COCONUT (EKAKSHI SHREEFAL)",
];

const getGemstoneType = (material) => {
  if (material === "PRECIOUS") return "PRECIOUS";
  if (material === "SEMI-PRECIOUS") return "SEMI-PRECIOUS";
  if (material === "LAB GROWN (LGD)") return "LAB GROWN (LGD)";
  return null;
};

const ProductGrid = () => {
  const [products, setProducts] = useState([]);
  const [sortBy, setSortBy] = useState("newest");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPrice, setSelectedPrice] = useState("");
  const [selectedMaterial, setSelectedMaterial] = useState("");
  const [selectedGemstone, setSelectedGemstone] = useState("");
  const [selectedGemstoneShape, setSelectedGemstoneShape] = useState("");
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Always scroll to top when this page is opened
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Parse filters from query string
  const getFiltersFromQuery = () => {
    const searchParams = new URLSearchParams(location.search);
    return {
      material: searchParams.get("material") || "",
      product: searchParams.get("product") || "",
      price: searchParams.get("price") || "",
      search: searchParams.get("search") || "",
      gemstone: searchParams.get("gemstone") || "",
      gemstoneShape: searchParams.get("gemstoneShape") || "",
    };
  };

  // Update URL query for price
  const updateQuery = (priceValue) => {
    const searchParams = new URLSearchParams(location.search);
    if (priceValue) {
      searchParams.set('price', priceValue);
    } else {
      searchParams.delete('price');
    }
    navigate({ search: searchParams.toString() }, { replace: true });
  };

  // Add a handler for material selection
  const handleMaterialChange = (e) => {
    const value = e.target.value;
    setSelectedMaterial(value);
    const searchParams = new URLSearchParams(location.search);
    if (value) {
      searchParams.set('material', value);
    } else {
      searchParams.delete('material');
    }
    navigate({ search: searchParams.toString() }, { replace: true });
  };

  // Update URL query for specific gemstone
  const handleGemstoneChange = (e) => {
    const value = e.target.value;
    setSelectedGemstone(value);
    setSelectedGemstoneShape(""); // Reset shape when gemstone changes
    const searchParams = new URLSearchParams(location.search);
    if (value) {
      searchParams.set("gemstone", value);
    } else {
      searchParams.delete("gemstone");
    }
    searchParams.delete("gemstoneShape"); // Remove shape filter when gemstone changes
    navigate({ search: searchParams.toString() }, { replace: true });
  };

  // Update URL query for gemstone shape
  const handleGemstoneShapeChange = (e) => {
    const value = e.target.value;
    setSelectedGemstoneShape(value);
    const searchParams = new URLSearchParams(location.search);
    if (value) {
      searchParams.set("gemstoneShape", value);
    } else {
      searchParams.delete("gemstoneShape");
    }
    navigate({ search: searchParams.toString() }, { replace: true });
  };

  // Fetch products
  const fetchProducts = async () => {
    setIsLoading(true);
    try {
      const { material, product, price, search, gemstone, gemstoneShape } = getFiltersFromQuery();
      const queryParams = { 
        sort: sortBy,
        limit: 'all' // Request all products instead of default 10
      };
      if (GEMSTONE_TYPES.includes(material)) {
        queryParams.material = material;
        if (gemstone) queryParams.gemstone = gemstone;
        if (gemstoneShape) queryParams.gemstoneShape = gemstoneShape;
      } else if (material) {
        queryParams.material = material;
      }
      if (product) queryParams.product = product;
      if (price) queryParams.price = price;
      if (search) queryParams.search = search;
      const res = await axios.get(`${API_BASE}/products`, {
        params: queryParams,
      });
      setProducts(res.data);
    } catch (err) {
      console.error("Failed to load products:", err);
    }
    setIsLoading(false);
  };

  // Fetch when sort/filter changes
  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line
  }, [location.search, sortBy]);

  // On mount and when location changes, set state from query
  useEffect(() => {
    const { price, material, gemstone, gemstoneShape } = getFiltersFromQuery();
    setSelectedPrice(price || "");
    setSelectedMaterial(material || "");
    setSelectedGemstone(gemstone || "");
    setSelectedGemstoneShape(gemstoneShape || "");
  }, [location.search]);

  // Handle price bucket change
  const handlePriceChange = (e) => {
    const value = e.target.value;
    setSelectedPrice(value);
    updateQuery(value);
  };

  // Handle sort change
  const handleSortChange = (e) => {
    setSortBy(e.target.value);
  };

  // Close mobile filter after applying filter
  const handleMobileFilterChange = (handler, value) => {
    handler(value);
    // Close mobile filter after a short delay to show the change
    setTimeout(() => {
      setIsMobileFilterOpen(false);
    }, 500);
  };

  // Mobile filter handlers
  const handleMobileMaterialChange = (e) => {
    const value = e.target.value;
    setSelectedMaterial(value);
    const searchParams = new URLSearchParams(location.search);
    if (value) {
      searchParams.set('material', value);
    } else {
      searchParams.delete('material');
    }
    navigate({ search: searchParams.toString() }, { replace: true });
  };

  const handleMobilePriceChange = (e) => {
    const value = e.target.value;
    setSelectedPrice(value);
    updateQuery(value);
  };

  const handleMobileSortChange = (e) => {
    setSortBy(e.target.value);
  };

  const { material } = getFiltersFromQuery();
  const gemstoneType = getGemstoneType(material);
  const dropdownOptions = gemstoneType ? GEMSTONE_OPTIONS[gemstoneType] : MATERIALS;

  // If coming from gemstone menu (material is a gemstone type), show gemstone dropdown
  const showGemstoneDropdown = GEMSTONE_TYPES.includes(selectedMaterial);
  // If material is from Spiritual Collection (e.g. RUDRAKSH), show Spiritual Collection dropdown instead of Jewelry Type
  const showSpiritualDropdown = SPIRITUAL_ITEMS.includes(selectedMaterial);
  return (
    <div className="product-page-container">
      {/* Desktop Filters */}
      <div className="desktop-filters">
        <div className="product-sort-filter" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
            {showGemstoneDropdown ? (
              <>
                <select value={selectedGemstone} onChange={handleGemstoneChange} style={{ padding: 10, borderRadius: 6 }}>
                  <option value="">Choose Your Gemstone</option>
                  {GEMSTONE_OPTIONS[selectedMaterial].map((gem) => (
                    <option key={gem} value={gem}>{gem}</option>
                  ))}
                </select>
                {selectedGemstone && (
                  <select value={selectedGemstoneShape} onChange={handleGemstoneShapeChange} style={{ padding: 10, borderRadius: 6 }}>
                    <option value="">Choose Shape</option>
                    {GEMSTONE_SHAPES.map((shape) => (
                      <option key={shape} value={shape}>{shape}</option>
                    ))}
                  </select>
                )}
              </>
            ) : null}
            <select value={selectedPrice} onChange={handlePriceChange} style={{ padding: 10, borderRadius: 6 }}>
              {PRICE_RANGES.map((range) => (
                <option key={range.value} value={range.value}>{range.label}</option>
              ))}
            </select>
            {showSpiritualDropdown && (
              <select value={selectedMaterial} onChange={handleMaterialChange} style={{ padding: 10, borderRadius: 6 }}>
                <option value="">Spiritual Collection</option>
                {SPIRITUAL_ITEMS.map((item) => (
                  <option key={item} value={item}>{item}</option>
                ))}
              </select>
            )}
          <select value={sortBy} onChange={handleSortChange}>
            <option value="newest">Newest First</option>
            <option value="bestselling">Best Selling</option>
            <option value="price_low">Price: Low to High</option>
            <option value="price_high">Price: High to Low</option>
          </select>
        </div>
      </div>

      {/* Mobile Filter Toggle */}
      <div className="mobile-filter-toggle">
        <button 
          className="filter-toggle-btn"
          onClick={() => setIsMobileFilterOpen(!isMobileFilterOpen)}
        >
          <FaFilter />
          <span>Filters</span>
        </button>
      </div>

      {/* Mobile Filter Sidebar */}
      <div className={`mobile-filter-sidebar ${isMobileFilterOpen ? 'open' : ''}`}>
        <div className="mobile-filter-header">
          <h3>Filters</h3>
          <button 
            className="close-filter-btn"
            onClick={() => setIsMobileFilterOpen(false)}
          >
            <FaTimes />
          </button>
        </div>
        
        <div className="mobile-filter-content">
          {showGemstoneDropdown ? (
            <div className="mobile-filter-section">
              <label>Choose Your Gemstone</label>
              <select
                value={selectedMaterial}
                onChange={handleMobileMaterialChange}
                className="mobile-filter-select"
              >
                <option value="">Choose Your Gemstone</option>
                {dropdownOptions.map((mat) => (
                  <option key={mat} value={mat}>{mat}</option>
                ))}
              </select>
            </div>
          ) : showSpiritualDropdown ? (
            <div className="mobile-filter-section">
              <label>Spiritual Collection</label>
              <select
                value={selectedMaterial}
                onChange={handleMobileMaterialChange}
                className="mobile-filter-select"
              >
                <option value="">Spiritual Collection</option>
                {SPIRITUAL_ITEMS.map((item) => (
                  <option key={item} value={item}>{item}</option>
                ))}
              </select>
            </div>
          ) : null}

          {showGemstoneDropdown && selectedGemstone && (
            <div className="mobile-filter-section">
              <label>Gemstone Shape</label>
              <select 
                value={selectedGemstoneShape} 
                onChange={(e) => handleMobileFilterChange(handleGemstoneShapeChange, e)}
                className="mobile-filter-select"
              >
                <option value="">Choose Shape</option>
                {GEMSTONE_SHAPES.map((shape) => (
                  <option key={shape} value={shape}>{shape}</option>
                ))}
              </select>
            </div>
          )}

          <div className="mobile-filter-section">
            <label>Price Range</label>
            <select 
              value={selectedPrice} 
              onChange={handleMobilePriceChange}
              className="mobile-filter-select"
            >
              {PRICE_RANGES.map((range) => (
                <option key={range.value} value={range.value}>{range.label}</option>
              ))}
            </select>
          </div>

          <div className="mobile-filter-section">
            <label>Sort By</label>
            <select 
              value={sortBy} 
              onChange={handleMobileSortChange}
              className="mobile-filter-select"
            >
              <option value="newest">Newest First</option>
              <option value="bestselling">Best Selling</option>
              <option value="price_low">Price: Low to High</option>
              <option value="price_high">Price: High to Low</option>
            </select>
          </div>

          <div className="mobile-filter-actions">
            <button 
              className="apply-filters-btn"
              onClick={() => setIsMobileFilterOpen(false)}
            >
              Apply Filters
            </button>
            <button 
              className="clear-filters-btn"
              onClick={() => {
                setSelectedMaterial("");
                setSelectedPrice("");
                setSelectedGemstone("");
                setSelectedGemstoneShape("");
                setSortBy("newest");
                navigate({ search: "" }, { replace: true });
                setIsMobileFilterOpen(false);
              }}
            >
              Clear All
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Filter Overlay */}
      {isMobileFilterOpen && (
        <div 
          className="mobile-filter-overlay"
          onClick={() => setIsMobileFilterOpen(false)}
        />
      )}

      {/* Product grid and empty state */}
      {!isLoading && products.length === 0 ? (
        <div className="no-products-message">
          <h3>No products found in this category</h3>
          <p>
            We are adding new designs soon. Please try a different category or clear the filters to see all products.
          </p>
          <button
            className="no-products-button"
            onClick={() => {
              navigate("/store");
              navigate({ search: "" }, { replace: true });
            }}
          >
            Browse all products
          </button>
        </div>
      ) : (
        <>
          <div className="product-grid">
            {products.map((product) => (
              <ProductCard product={product} key={product._id} />
            ))}
          </div>
          {products.length > 0 && (
            <p style={{ textAlign: "center", padding: "1rem" }}>
              No more products.
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default ProductGrid;
